var DataCardComponent = /** @class */ (function () {
    function DataCardComponent() {
    }
    return DataCardComponent;
}());
export { DataCardComponent };
